/** CallSyncCRMRelatedToSearchInputBoxContainer is an AltContainer for <CallSyncCRMRelatedToSearchInputBox/>
 */
import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';
import React from 'react';

import CrmSyncAccountAndOpportunitiesStore from 'stores/crm/CrmSyncAccountAndOpportunitiesStore';
import CrmSyncAccountsAndOpportunitiesPrefixSearchStore from 'stores/crm/CrmSyncAccountsAndOpportunitiesPrefixSearchStore';
import CrmSyncContactsAndLeadsPrefixSearchStore from 'stores/crm/CrmSyncContactsAndLeadsPrefixSearchStore';
import CallSyncCRMRelatedToSearchInputBox from 'components/pure/call-card/sync-crm/CallSyncCRMRelatedToSearchInputBox';

class CallSyncCRMRelatedToSearchInputBoxContainer extends React.Component {
  static getStores() {
    return [
      CrmSyncContactsAndLeadsPrefixSearchStore,
      CrmSyncAccountAndOpportunitiesStore,
      CrmSyncAccountsAndOpportunitiesPrefixSearchStore,
    ];
  }

  /**
   * Return the current value selected inside CrmSyncContactsAndLeadsPrefixSearchStore which dictates whether
   * <CallSyncCRMRelatedToSearchInputBox/> should be active and searchable or not. Also return the options, total and
   * numReturned metadata of the accounts and opportunities from two related stores: one store for
   * account-and-opportunities from contact-account-id and another one for accounts-and-opportunities from prefix-search
   */
  static getPropsFromStores() {
    const contactsAndLeadsStoreState = CrmSyncContactsAndLeadsPrefixSearchStore.getState();
    const accountAndOpportunitiesStoreState = CrmSyncAccountAndOpportunitiesStore.getState();
    const accountsAndOpportunitiesPrefixSearchStoreState =
      CrmSyncAccountsAndOpportunitiesPrefixSearchStore.getState();
    return {
      contactsAndLeadsValue: contactsAndLeadsStoreState.get('values').first(),
      accountAndOpportunitiesValue: accountAndOpportunitiesStoreState.get('values').first(),
      // accountAndOpportunities return crm account-and-opportunities for a given contact-account-id
      accountAndOpportunities: accountAndOpportunitiesStoreState.get('options'),
      // accountsAndOpportunitiesFromPrefixSearch returns crm accounts-and-opportunities for a given search prefix
      accountsAndOpportunitiesFromPrefixSearch:
        accountsAndOpportunitiesPrefixSearchStoreState.get('options'),
      accountsAndOpportunitiesNumReturned:
        accountsAndOpportunitiesPrefixSearchStoreState.get('numReturned'),
      accountsAndOpportunitiesTotal: accountsAndOpportunitiesPrefixSearchStoreState.get('total'),
      // prefixSearchLoading stores the current state of request loading status for the related-to search input box
      prefixSearchLoading: accountsAndOpportunitiesPrefixSearchStoreState.get('loading'),
    };
  }

  static accountOrOpportunityValues(
    accountAndOpportunityStoreState,
    accountsAndOpportunitiesPrefixSearchStoreState
  ) {}

  render() {
    return (
      <AltContainer>
        <CallSyncCRMRelatedToSearchInputBox {...this.props} />
      </AltContainer>
    );
  }
}

export default connectToStores(CallSyncCRMRelatedToSearchInputBoxContainer);
